import { ContactBlock } from 'src/types';
import css from './contacts.module.scss';
import { ReactComponent as ArrowRight } from 'src/assets/arrow-long-right.svg';
import { Link } from 'react-router-dom';
import PaginatedFooter from 'src/components/paginated-footer/paginated-footer';
import { useMemo, useState } from 'react';

interface Props {
  blocks: ContactBlock[];
}

export default function BlockCard({ blocks }: Readonly<Props>) {
  const [showAll, setShowAll] = useState(false);
  const [quantity, setQuantity] = useState(5);
  const blocksToShow = useMemo(
    () =>
      blocks?.slice(0, quantity).map((b) => (
        <Link to={b.slug} key={b.id}>
          {b.title} <ArrowRight />
        </Link>
      )),
    [blocks, quantity]
  );

  return (
    <div className={css.blockCard}>
      {blocksToShow}
      {!showAll && blocks.length > quantity && (
        <div className={css.pagerRow}>
          <PaginatedFooter
            caption='Більше розділів'
            disabled={false}
            onClick={() => {
              setShowAll(true);
              setQuantity(blocks.length);
            }}
          />
        </div>
      )}
    </div>
  );
}
